import { render, staticRenderFns } from "./feature-card-community.vue?vue&type=template&id=5a8daf04&scoped=true&"
import script from "./feature-card-community.vue?vue&type=script&lang=js&"
export * from "./feature-card-community.vue?vue&type=script&lang=js&"
import style0 from "./feature-card-community.vue?vue&type=style&index=0&id=5a8daf04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8daf04",
  null
  
)

export default component.exports